import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/home-webapp/src/contexts/pages/market/MarketProvider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Grid/Grid.js");
